import { ElMessage } from "element-plus";


export function XLToastSuccess(message){
    if (message){
        ElMessage.success(message)
    }
}

export function XLToastWarning(message){
    if (message){
        ElMessage.warning(message)
    }
}

export function XLToastError(message){
    if (message){
        ElMessage.error(message)
    }
}

export function XLToast(message){
    if (message){
        ElMessage(message)
    }
}